import {
  GET_TERMINALS_FAILD,
  GET_TERMINALS_LOADING,
  GET_TERMINALS_SUCCESS,
  GET_TERMINALS_REMOVE
} from "../types";

const initialState = {
  terminals: null,
  loading: null,
  error: null,
};

export const getTerminalsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_TERMINALS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        terminals: action.payload,
      };
    case GET_TERMINALS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_TERMINALS_REMOVE:
      return initialState;
    default:
      return state;
  }
};
